import { apiClient } from 'src/careflow/ph-core/api_client/api_client';

export const COMX_EMBED_CONFIG_PATH = '/host-api/comx/embed/config';
export const ICOMX_SUPPORTED_RESOURCE_TYPES = ['Patient', 'Practitioner'] as const;

export type IcomxResourceType = typeof ICOMX_SUPPORTED_RESOURCE_TYPES[number];

export interface IcomxResourceDescriptor {
  resourceType: IcomxResourceType;
  resourceId: string;
}

export const getComxResourceLinkPath = ({ resourceType, resourceId }: IcomxResourceDescriptor) =>
  `/host-api/resources/${resourceType}/${resourceId}/comx-link`;

export const ensureComxResourceLinkPath = ({ resourceType, resourceId }: IcomxResourceDescriptor) =>
  `/host-api/resources/${resourceType}/${resourceId}/comx-link/ensure`;

export const syncComxResourceLinkPath = ({ resourceType, resourceId }: IcomxResourceDescriptor) =>
  `/host-api/resources/${resourceType}/${resourceId}/comx-link/sync`;

export interface IcomxEmbedConfig {
  enabled: boolean;
  iframeUrl: string | null;
  iframeOrigin: string | null;
  tenantKey: string | null;
}

export interface IcomxResourceLink extends IcomxResourceDescriptor {
  resourceReferenceUri: string;
  hasMapping: boolean;
  comxContactUuid: string | null;
  status: string;
}

export interface EnsureIcomxResourceLinkResponse extends IcomxResourceDescriptor {
  resourceReferenceUri: string;
  comxContactUuid: string | null;
  status: string;
  created: boolean;
}

export async function getIcomxEmbedConfig() {
  return apiClient.get<IcomxEmbedConfig>(COMX_EMBED_CONFIG_PATH);
}

export async function getIcomxResourceLink(resource: IcomxResourceDescriptor) {
  return apiClient.get<IcomxResourceLink>(getComxResourceLinkPath(resource));
}

export async function ensureIcomxResourceLink(resource: IcomxResourceDescriptor) {
  return apiClient.post<undefined, EnsureIcomxResourceLinkResponse>(
    ensureComxResourceLinkPath(resource),
    undefined
  );
}

export async function syncIcomxResourceLink(resource: IcomxResourceDescriptor) {
  return apiClient.post<undefined, EnsureIcomxResourceLinkResponse>(
    syncComxResourceLinkPath(resource),
    undefined
  );
}